export class IPostPackTypesBodyDto {
  name: string;
}

import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export class PackTypes {
  id: number;
  name: string;
}

export class IPackTypesResponse {
  @Type(() => PackTypes)
  result: PackTypes;
}

export class IPackTypesListResponse extends IPagination {
  @Type(() => PackTypes)
  results: PackTypes[];
}

export class IPackTypesQueryDto extends IQueryPaginationDto {
  name?: string;
}

export class IPackTypesPatchBodyDto {
  name?: string;
}
